import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Form
} from 'reactstrap';
import moment from 'moment';

import { makeInput } from "common-import/custom";

class EmailSender extends Component {

  state = {
    listEmail: [],
    name: '',
    email: ''
  }

  async componentDidMount() {
    this.getEmailSender();
  }

  render() {
    const { listEmail } = this.state;
    return (
      <div className="animated fadeIn">

        <p>Mỗi lần hệ thông gửi email, sẽ dùng 1 trong số các email được chọn dưới đây để làm email nguồn </p>
        <Row>
          <Col md="12">
            {listEmail.map((val, index) => this.renderEachEmailSender(val, index))}
          </Col>
        </Row>
        <Form onSubmit={this.createEmail} style={{marginTop: 25}}>
          <Row>
            <Col md="4">
              {makeInput(this, "email")(<Input type="text" placeholder="Email"  />)}
            </Col>
            <Col md="4">
              {makeInput(this, "name")(<Input type="text" placeholder="Name" />)}
            </Col>
            <Col md="4">
              <Input type="submit" className="btn btn-danger" value="Tạo Email Sender mới" onClick={this.createEmail} />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  renderEachEmailSender = (val, index) => {
    return (
      <div key={"email"+index} style={styles.emailContainer}>
        <div style={{ width: 50, display: 'flex', justifyItems: 'center', alignItems: 'center' }}>
          <input type="checkbox" checked={val.isChosen} onChange={() => this.toggleEmail(val)} />
        </div>
        <div style={{flex:1}}>
          <h3 style={{color: 'green'}}>{val.email}</h3>
          <p>Name: {val.name}</p>
        </div>
      </div>
    )
  }

  getEmailSender = async () => {
    let res = await fetch("http://houselink.xuongapp.com:4444/notification/email", {
      method: "GET",
      headers: { "Authorization": "kgmdqtveva" }
    });
    let json = await res.json();
    this.setState({ listEmail: json.status === "OK" ? json.result : [] });
  }

  toggleEmail = async (val) => {
    let { listEmail } = this.state;
    let thisEmail = listEmail.find(item => item.email == val.email);
    thisEmail.isChosen = !thisEmail.isChosen;
    this.setState({ listEmail });
    fetch("http://houselink.xuongapp.com:4444/notification/email", {
      method: "POST",
      headers: { "Authorization": "kgmdqtveva", "Content-Type": "application/json" },
      body: JSON.stringify(thisEmail)
    });
  }

  createEmail = async e => {
    !!e && e.preventDefault();
    const { email, name, listEmail } = this.state;
    let newEmail = { email, name, isChosen: true };
    listEmail.push(newEmail);
    this.setState({ listEmail, email: "", name: "" });
    fetch("http://houselink.xuongapp.com:4444/notification/email", {
      method: "POST",
      headers: { "Authorization": "kgmdqtveva", "Content-Type": "application/json" },
      body: JSON.stringify(newEmail)
    });
  }
}

const styles = {
  emailContainer: { 
    backgroundColor: 'white', 
    padding: 10, 
    display: 'flex',
    flexDirection: 'row' 
  }
}

export default EmailSender;


// WEBPACK FOOTER //
// ./src/views/Dashboard/EmailSender.js